/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reportpb/fractionalsharepl.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.reportpb = require('./fractionalsharepl_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.FractionalSharePLServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.FractionalSharePLServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListFractionalSharePLRequest,
 *   !proto.reportpb.ListFractionalSharePLResponse>}
 */
const methodDescriptor_FractionalSharePLService_ListFractionalSharePL = new grpc.web.MethodDescriptor(
  '/reportpb.FractionalSharePLService/ListFractionalSharePL',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListFractionalSharePLRequest,
  proto.reportpb.ListFractionalSharePLResponse,
  /**
   * @param {!proto.reportpb.ListFractionalSharePLRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListFractionalSharePLResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListFractionalSharePLRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.ListFractionalSharePLResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListFractionalSharePLResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.FractionalSharePLServiceClient.prototype.listFractionalSharePL =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.FractionalSharePLService/ListFractionalSharePL',
      request,
      metadata || {},
      methodDescriptor_FractionalSharePLService_ListFractionalSharePL,
      callback);
};


/**
 * @param {!proto.reportpb.ListFractionalSharePLRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListFractionalSharePLResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.FractionalSharePLServicePromiseClient.prototype.listFractionalSharePL =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.FractionalSharePLService/ListFractionalSharePL',
      request,
      metadata || {},
      methodDescriptor_FractionalSharePLService_ListFractionalSharePL);
};


module.exports = proto.reportpb;

